import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingStatus': false,
  'list': [],
};

export const obsolescenceParameters = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_OBSOLESCENCE_PARAMETERS_REQUEST]: (state, action) => ({
      ...state,
      'loadingStatus': true,
    }),
    [ActionTypes.FETCH_OBSOLESCENCE_PARAMETERS_FAILED]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'list': [],
    }),
    [ActionTypes.FETCH_OBSOLESCENCE_PARAMETERS_SUCCCESS]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'list': action.response.data,
    }),
  })(state, action);
};
